module.exports = __webpack_public_path__ + "img/at (4).396063e6.jpg";